import React, { useMemo, FC, MouseEvent, ReactNode } from 'react'
import useMenuButton, { useMenuButtonProps } from '../hooks/useMenuButton'
import IconButton from '@mui/material/IconButton'
import icons from '../../icons'

const MoreVertIcon = icons.moreVert

interface MenuButtonProps extends useMenuButtonProps {
  className?: string,
  getButton?: (onClick: (e: MouseEvent) => void) => ReactNode,
}

const MenuButton: FC<React.PropsWithChildren<MenuButtonProps>> = ({
  // the classname for the root item
  className,
  // a function that is called (onClick) to render the button
  getButton = (onClick) => {
    return (
      <IconButton onClick={ onClick } size="large">
        <MoreVertIcon />
      </IconButton>
    );
  },
  ...other
}) => {

  const {
    menus,
    onClick,
  } = useMenuButton(other)
  
  const button = useMemo(
    () => getButton(onClick),
    [
      getButton,
      onClick,
    ]
  )

  return (
    <div className={ className }>
      { button }
      { menus }
    </div>
  )
}

export default MenuButton